import {StepSection} from '../StepSection'
import {AddedFiles, AddFileField, TextWithTooltip} from './SharedComponents'
import {ServiceFields} from '../../../../../model/NewItemInput'
import { Label } from '../../../../../../genericComponents/typographie/Label'

export const EvidenceDocumentsSection = () => {

    return <StepSection title="Evidence Documents">
        <div className="service-form-section">
            <div className="service-form-field">
                <TextWithTooltip
                    label={<Label required>Attach relevant records confirming the existence of the item (Please upload <strong>at
                        least 1
                        file/
                        URL</strong>)</Label>}
                    tooltip="Eg. Data Sheet, Safety Data Sheet, Purchase Order, etc"/>
                <AddFileField target={`${ServiceFields.EvidenceDocuments}.proofs`}/>
            </div>
            <AddedFiles target={`${ServiceFields.EvidenceDocuments}.proofs`}/>
        </div>
    </StepSection>
}
